/**
 * Hero section component for FreeAccount page
 * @author Housefolios
 * @modifiedBy David Helmick
 * @modifiedTime 2025-06-17 14:05:00
 */

import React from 'react'
import { Grid, Typography, Box } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import NewLogo from '@/assets/images/NewLogo.png'

const HeroSection = () => {
  return (
    <Box style={{ backgroundColor: '#368CFF' }} sx={[{ width: '100%' }, {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      "& > .divider": { zIndex: 7, width: "100%" },
      "& .hero-footer": { zIndex: 7 },
      "& .header-nav-wrapper": { zIndex: 27 },
      "& .bg-composed-wrapper--image": { backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center center" },
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit",
      alignItems: "center",
      ".MuiCard-root > &": {
        top: -1,
        marginLeft: -1,
        marginRight: -1,
        marginBottom: -2,
        zIndex: 6,
      },
    }]}>
      <Grid
        container

        sx={{
          minHeight: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Grid>
          <Grid
            container
            direction="column"
            spacing={3}
            style={{ padding: 50 }}
          >
            <Grid style={{ textAlign: 'center', marginBottom: 10 }}>
              <img alt="Housefolios" src={NewLogo} />
            </Grid>

            {/* Feature 1 */}
            <Grid>
              <Grid
                container
                direction="row"
                spacing={2}
                sx={{
                  alignItems: 'center',
                }}
              >
                <Grid size={1} style={{ textAlign: 'center' }}>
                  <FontAwesomeIcon
                    icon={['far', 'house-laptop']}
                    style={{ color: 'white', fontSize: 36 }}
                  />
                </Grid>
                <Grid size={11}>
                  <Typography
                    style={{ color: 'white', marginLeft: 10 }}
                  >
                    Analyze an investment property in seconds, not
                    hours
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Feature 2 */}
            <Grid>
              <Grid
                container
                direction="row"
                spacing={2}
                sx={{
                  alignItems: 'center',
                }}
              >
                <Grid size={1} style={{ textAlign: 'center' }}>
                  <img
                    src="images/nationIcon.png"
                    alt="Nationwide Search"
                    style={{ width: 40, padding: 0 }}
                  />
                </Grid>
                <Grid size={11}>
                  <Typography
                    style={{ color: 'white', marginLeft: 10 }}
                  >
                    Search nationwide for properties across all active
                    MLS listings
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Feature 3 */}
            <Grid>
              <Grid
                container
                direction="row"
                spacing={2}
                sx={{
                  alignItems: 'center',
                }}
              >
                <Grid size={1} style={{ textAlign: 'center' }}>
                  <FontAwesomeIcon
                    icon={['far', 'arrow-down-wide-short']}
                    style={{ color: 'white', fontSize: 36 }}
                  />
                </Grid>
                <Grid size={11}>
                  <Typography
                    style={{ color: 'white', marginLeft: 10 }}
                  >
                    Filter and review specific investing strategies
                    like fix & flip, buy & hold, turnkey, and more
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Feature 4 */}
            <Grid>
              <Grid
                container
                direction="row"
                spacing={2}
                sx={{
                  alignItems: 'center',
                }}
              >
                <Grid size={1} style={{ textAlign: 'center' }}>
                  <FontAwesomeIcon
                    icon={['fas', 'sign-hanging']}
                    style={{ color: 'white', fontSize: 36 }}
                  />
                </Grid>
                <Grid size={11}>
                  <Typography
                    style={{ color: 'white', marginLeft: 10 }}
                  >
                    List your properties on your own customizable
                    website
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Feature 5 */}
            <Grid>
              <Grid
                container
                direction="row"
                spacing={2}
                sx={{
                  alignItems: 'center',
                }}
              >
                <Grid size={1} style={{ textAlign: 'center' }}>
                  <FontAwesomeIcon
                    icon={['far', 'file-chart-column']}
                    style={{ color: 'white', fontSize: 36 }}
                  />
                </Grid>
                <Grid size={11}>
                  <Typography
                    style={{ color: 'white', marginLeft: 10 }}
                  >
                    Generate proformas with a single click
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Testimonial */}
            <Grid style={{ padding: 25 }}>
              <Grid container direction="column">
                <Grid
                  style={{
                    padding: 10,
                    border: 'solid',
                    borderWidth: 3,
                    borderColor: 'white',
                    borderRadius: 5,
                  }}
                >
                  <Typography
                    align="center"
                    style={{ color: 'white' }}
                  >
                    "I used to hire analysts or virtual assistants to
                    help me find properties...
                    <b>
                      Housefolios is cheaper and frankly makes a lot
                      less mistakes
                    </b>
                    ."
                  </Typography>
                  <Typography
                    align="center"
                    style={{ color: 'white', marginTop: 5 }}
                  >
                    -Rob, California
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default HeroSection
